import { useLazyQuery } from '@apollo/client'
import { Button } from '@/atoms/Button'
import { DownloadIcon } from '@/atoms/Icons/DownloadIcon'
import { ParagraphSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { useTorchApplication } from '../../components/TorchApplicationContext'
import { GET_SIGNED_PDF_URL } from '../../queries'

export const FilmmakerApplication = () => {
  const { t } = useTranslate('guild-create')
  const { data, id } = useTorchApplication()

  const [getSignedPdfUrl] = useLazyQuery(GET_SIGNED_PDF_URL, {
    variables: { id },
    onCompleted: (data) => {
      window.open(data?.torchApplication?.signedPdfUrl, '_blank')
    },
    errorPolicy: 'all',
  })

  const handleDownload = () => {
    getSignedPdfUrl()
  }

  const signatureDate = data?.signatureDate ? new Date(data.signatureDate) : null

  return (
    <div className="mx-6">
      <ParagraphSM weight="bold">
        {t('signedElectronicallyOn', 'Signed electronically on')} {signatureDate?.toLocaleDateString()}{' '}
        {signatureDate?.toLocaleTimeString()}
      </ParagraphSM>

      <Button variant="lightgray" onClick={handleDownload} className="flex items-center justify-between gap-2">
        <DownloadIcon size={24} color="gray-800" />
        {t('download', 'Download')}
      </Button>
    </div>
  )
}
